<template>
  <el-dialog
    :title="'报告查询'"
    :visible.sync="visible"
    width="850px"
    @close="handleClose"
  >
    <el-form
      ref="queryForm"
      :model="queryForm"
      :rules="rules"
      label-width="70px"
      class="query-form"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="姓名" prop="patientName">
            <el-input
              v-model="queryForm.patientName"
              placeholder="请输入患者姓名"
              clearable
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生日">
            <el-date-picker
              v-model="queryForm.birthday"
              type="date"
              placeholder="选择生日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%;"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="性别">
            <el-select
              v-model="queryForm.gender"
              placeholder="选择性别"
              clearable
              style="width: 100%;"
            >
              <el-option label="男" value="MALE" />
              <el-option label="女" value="FEMALE" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label-width="20px">
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 集成ReportList组件 -->
    <div class="report-list-container">
      <ReportList v-if="showReportList" :searchParams="searchParams" />
    </div>
  </el-dialog>
</template>

<script>
import ReportList from './ReportList.vue'

export default {
  name: 'ReportQueryDialog',
  components: {
    ReportList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      queryForm: {
        patientName: '',
        birthday: '',
        gender: ''
      },
      searchParams: {}, // 用于传递给ReportList的搜索参数
      rules: {
        patientName: [
          { required: false, message: '请输入患者姓名', trigger: 'blur' } // 改为非必填
        ]
      },
      showReportList: false, // 控制报告列表是否显示
      // 日期选择器配置，限制只能选择今天以前的日期
      pickerOptions: {
        disabledDate(time) {
          return time > new Date(); // 只能选择今天及之前的日期
        }
      }
    };
  },
  watch: {
    // 当对话框可见时自动执行查询
    visible: {
      handler(newVal) {
        if (newVal) {
          // 短暂延迟确保对话框完全渲染
          setTimeout(() => {
            this.handleSearch();
          }, 100);
        }
      },
      immediate: false
    }
  },
  methods: {
    handleSearch() {
      this.$refs.queryForm.validate((valid) => {
        if (valid) {
          // 设置查询参数
          this.searchParams = {
            ...this.queryForm,
            gender: this.queryForm.gender === '全部' ? '' : this.queryForm.gender
          };
          this.showReportList = true; // 显示报告列表
        }
      });
    },
    handleClose() {
      // 重置表单
      this.$refs.queryForm.resetFields();
      // 触发父组件的关闭事件
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.query-form {
  margin-bottom: 10px;
}

.report-list-container {
  margin-top: 20px;
  border-top: 1px solid #e8e8e8;
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ReportQueryDialog.vue